import React, { useEffect, useRef } from "react";
import NonSsrWrapper from "@/components/wrappers/non-ssr-wrapper";
import { useStateContext } from "@/components/state";
import useEventListener from "@/hooks/EventListener";

const Wrapper = (props) => {
    const { state } = useStateContext();
    const { children, disabled, header, bodyHeight, setHeight, setHeader } = props;
    const ref = useRef();

    useEffect(() => {
        if (disabled) return;
        if (!ref.current) return;

        if (ref.current.clientHeight !== bodyHeight) {
            resize()
            setTimeout(() => {
                resize()
            }, 100);
        }
        if (state?.scenes?.header !== header) setHeader(header ?? "...");
    })

    const resize = () => {
        setHeight(ref.current.clientHeight);
    }

    let resizeTimeout;
    const resizeListener = (e) => {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        resizeTimeout = setTimeout(resize, 50);
    }
    useEventListener("resize", resizeListener);
    useEventListener("stale-filelist", resizeListener);

    return (
        <NonSsrWrapper>
            <div className={ ["form__page", disabled ? "form__page--disabled" : ""].join(" ") } ref={ref}>
                {children}
            </div>
        </NonSsrWrapper>
    );
};

export default Wrapper;
